import { Injectable, inject, Injector } from '@angular/core'
import { IAsset } from '../interfaces/asset.interface'
import { IBadgeSetting } from '../interfaces/badge.interface'
import { FinanceService } from './finance.service'

@Injectable({
  providedIn: 'root',
})
export class BadgeService {
  private injector = inject(Injector)
  private _financeService: FinanceService | null = null

  private get financeService(): FinanceService {
    if (!this._financeService) {
      this._financeService = this.injector.get(FinanceService)
    }
    return this._financeService
  }

  static readonly IS_FINANCING_ELIGIBLE_KEY = 'is_financing_eligible'

  public static readonly availableBadges: IBadgeSetting[] = [
    {
      key: 'is_featured',
      label: $localize`:@@badge.label.featured:Featured`,
    },
    {
      key: 'is_just_listed',
      label: $localize`:@@badge.label.just_listed:Just Listed`,
    },
    {
      key: 'is_low_hours',
      label: $localize`:@@badge.label.low_hours:Low Hours`,
    },
    {
      key: 'is_warranty_eligible',
      label: $localize`:@@badge.label.warranty:Warranty`,
    },
    {
      key: 'is_financing_eligible',
      label: $localize`:@@badge.label.financing:Financing`,
    },
  ]

  getBadgesForData(data: IAsset | undefined): IBadgeSetting[] {
    const badges: IBadgeSetting[] = []
    if (data === undefined) {
      return badges
    }

    BadgeService.availableBadges
      .filter(badge => data[badge.key] === true && (badge.key !== BadgeService.IS_FINANCING_ELIGIBLE_KEY || this.financeService.validateSettings()))
      .forEach(badge => {
        badges.push(badge)
      })
    return badges
  }
}
